import { registerComponent } from '@gig/magic-common';
import CurrencyBalanceComponent from './currency-balance.vue.js';

var CurrencyBalance = registerComponent(CurrencyBalanceComponent);

export { CurrencyBalance };
